import { RefObject, useCallback, useEffect, useRef } from 'react';

export function useAutoTextAreaSize(ref: RefObject<HTMLTextAreaElement | null>, grow: boolean, value?: string) {
    const prevValueRef = useRef<string | undefined>();

    const resize = useCallback(() => {
        if (ref.current && grow) {
            ref.current.style.height = 'auto';
            ref.current.style.height = `${ ref.current.scrollHeight }px`;
        }
    }, [ grow, ref ]);

    useEffect(function resizeOnChange() {
        if (value === prevValueRef.current) {
            return;
        }

        resize();
        prevValueRef.current = value;
    }, [ resize, value ]);

    useEffect(function resizeOnMount() {
        resize();
    }, [ resize ]);
}
